import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Text } from '../../../ui/Typography'
import { Flex } from '../../../ui/Layout'
import { Span } from '../../../ui/Typography'
import { openChat } from '../../../Components/ChatButton'

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.35);
  z-index: 110002;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ModalContent = styled.div`
  position: absolute;
  top: 62px;
  right: 16px;
  background: white;
  padding: 24px;
  border-radius: 16px;
  max-width: 360px;
  width: 100%;
  z-index: 110002;
`

const ListItem = styled.li`
  margin-bottom: 16px;
`

export const checkIfModalSeen = () => {
  let hasSeenHelpModal = false
  let isLocalStorageAvailable = false

  try {
    // Test if localStorage is available
    localStorage.setItem('test', 'test')
    localStorage.removeItem('test')
    isLocalStorageAvailable = true

    hasSeenHelpModal = localStorage.getItem('hasSeenHelpModal')
  } catch (e) {
    console.log('localStorage access failed:', e)
  }

  // Only check cookies if localStorage is available
  if (isLocalStorageAvailable) {
    try {
      hasSeenHelpModal = hasSeenHelpModal || document.cookie.includes('hasSeenHelpModal=true')
    } catch (e) {
      console.log('Cookie access failed:', e)
    }
  }

  return hasSeenHelpModal
}

export const markModalAsSeen = () => {
  try {
    localStorage.setItem('hasSeenHelpModal', 'true')
  } catch (e) {
    console.log('Failed to set localStorage:', e)
  }

  try {
    document.cookie = 'hasSeenHelpModal=true; max-age=31536000; path=/'
  } catch (e) {
    console.log('Failed to set cookie:', e)
  }
}

const HelpModal = ({ isOpen, onClose, showHelpModalFromUrl }) => {
  console.log({ isOpen })

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      document.body.style.overflow = 'hidden'
    }

    return () => {
      document.removeEventListener('keydown', handleEscape)
      document.body.style.overflow = 'unset'
    }
  }, [isOpen, onClose])

  useEffect(() => {
    if (showHelpModalFromUrl && !checkIfModalSeen()) {
      markModalAsSeen()
    }
  }, [showHelpModalFromUrl])

  if (!isOpen) return null

  return (
    <Overlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <Text fontSize="16px" fontWeight="600" lineHeight="25px">
          Welcome to the editor
        </Text>
        <Text light mb="20px" lineHeight="24px">
          A few quick tips:
        </Text>
        <Flex flexDirection="column">
          <Text>
            <ol style={{ paddingLeft: '20px' }}>
              <ListItem>
                <Text color="#4A5568">
                  Hover over thumbnails and click the '<Span fontWeight="700">image</Span>' icon to quickly change them.
                </Text>
              </ListItem>
              <ListItem>
                <Text color="#4A5568">
                  Change layouts, colors, play buttons, arrows and more in '<Span fontWeight="700">Design</Span>'.
                </Text>
              </ListItem>
              <ListItem>
                <Text color="#4A5568">
                  Use '<Span fontWeight="700">Content</Span>' to change videos and images in the campaign.
                </Text>
              </ListItem>
              <ListItem>
                <Text color="#4A5568">
                  Click '<Span fontWeight="700">Titles</Span>' to add and edit titles for your content
                </Text>
              </ListItem>
            </ol>
          </Text>
        </Flex>
        <Flex height="1px" backgroundColor="#EDF2F7" mb="16px" />
        <Flex mb="24px" flexDirection="column" gap="16px">
          <a
            href="https://clipara.notion.site/clipara/Clipara-Guides-1b7ea70c03d9433699335b05f336dd37"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Text color="#5B65F1" lineHeight="24px" fontWeight="500">
              Helpful guides
            </Text>
          </a>
          <Text
            cursor="pointer"
            color="#5B65F1"
            lineHeight="24px"
            fontWeight="500"
            onClick={() => {
              openChat()
              onClose()
            }}
          >
            Start a chat
          </Text>
        </Flex>
        <Text lightLight fontSize="12px" lineHeight="16px">
          You can reopen this at any time from the top right of the editor.
        </Text>
      </ModalContent>
    </Overlay>
  )
}

export default HelpModal
